var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandDiagonalLine = function SvgExpandDiagonalLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.155 6.167h-2.988V4.5H20v5.833h-1.667V7.345l-3.577 3.578-1.179-1.179zM5 13.667h1.667v2.988l3.577-3.578 1.179 1.179-3.578 3.577h2.988V19.5H5z"
  })));
};
export default SvgExpandDiagonalLine;